<template><finance-document-page document-type="receipt" /></template>
<script>
import FinanceDocumentPage from '../components/FinanceDocumentPage'
export default { name: 'ErpFinanceReceipt', components: { FinanceDocumentPage } }
</script>
